export const baseUrl = process.env.REACT_APP_CONNECTION_URL;
